import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import ResponseItem from './ResponseItem';
import Avatar from '../Avatar/Avatar';
import Link from '../Link/Link';

import messages from '../../locale/messages';
import StarRating from '../StarRating/StarRating';

import s from './Reviews.css';

const ReviewItemAboutYou = (props) => {
	const {
		picture,
		firstName,
		lastName,
		profileId,
		reviewContent,
		createdAt,
		response,
		otherUserResponse,
		showUserName,
		otherUserName,
		otherUserProfileId,
		isAdmin,
		listData,
		listTitle,
		rating,
		showReviewName
	} = props;

	const intl = useIntl();
	const formatMessage = intl.formatMessage;
	const siteName = useSelector((state) => state.siteSettings.data.siteName);

	const date = moment(parseInt(createdAt)).format('DD/MM/YYYY');

	const isGuestImage = response?.authorData?.picture;
	const isGuestProfileId = response?.authorData?.profileId;
	const showAvatar = !showUserName ? picture : isGuestImage;
	const isProfileId = !showUserName ? profileId : isGuestProfileId;

	return (
		<li>
			<div className={s.listAvatarGrid}>
				<div>
					{!isAdmin && (
						<div className={cx(s.pullRight, s.mediaContainer, s.textCenter, 'reviewsId')}>
							<Avatar
								source={picture}
								height={48}
								width={48}
								title={firstName}
								className={s.profileAvatar}
								withLink
								linkClassName={cx(s.profileAvatarLink, s.noBackground)}
								profileId={profileId}
							/>
						</div>
					)}

					{isAdmin && (
						<div className={cx(s.pullRight, s.mediaContainer, s.textCenter, 'reviewsId')}>
							<Avatar
								source='../../../adminAvatar.png'
								height={48}
								width={48}
								title={formatMessage(messages.verifiedBy) + ' ' + siteName}
								className={cx(s.profileAvatar, s.noBackground)}
								staticImage
							/>
						</div>
					)}
				</div>

				<div className={cx(s.listDeatilsGrid, 'listingTagCurve whiteBgCurve')}>
					<div className={s.reviewBody}>
						{showUserName && (
							<span className={s.textBold}>
								{listData ? (
									<>
										<FormattedMessage {...messages.Youhadreviewsfor} />{' '}
										<Link to={`/rooms/${listData.id}`}>{listTitle || listData.title}</Link>
									</>
								) : (
									<FormattedMessage {...messages.listingNotAvailable} />
								)}
							</span>
						)}

						{isAdmin && <div className={s.nameBold}>{formatMessage(messages.verifiedBy) + ' ' + siteName}</div>}

						{!isAdmin && !showUserName && (
							<div className={s.nameBold}>
								{listData ? (
									<>
										<Link to={`/users/show/${profileId}`}>{firstName}</Link>
										<span>
											' <FormattedMessage {...messages.sreview} />{' '}
										</span>
										<Link to={`/rooms/${listData.id}`}>{listTitle || listData.title}</Link>
									</>
								) : (
									<FormattedMessage {...messages.listingNotAvailable} />
								)}
							</div>
						)}

						{reviewContent && (
							<div className={s.reviewFlex}>
								<StarRating className='smallStarRatingAdjust' />
								<div>{rating}</div>
								<div className={cx(s.dateReviewCss, 'dateReviewCssRTL')}>
									{date}
								</div>
							</div>
						)}

						<p className={cx(s.contentTop, { [s.noResponse]: !response })}>
							{reviewContent &&
								reviewContent
									.trim()
									.split('\n')
									.map((content, index) => (
										<span key={index}>
											{content}
											<br />
										</span>
									))}
						</p>

						{response && (
							<ResponseItem
								data={response}
								otherUserResponse={otherUserResponse}
								date={date}
								showReviewName={showReviewName}
							/>
						)}
					</div>
				</div>
			</div>
		</li>
	);
};

ReviewItemAboutYou.propTypes = {
	picture: PropTypes.string,
	firstName: PropTypes.string,
	lastName: PropTypes.string,
	profileId: PropTypes.number,
	reviewContent: PropTypes.string,
	createdAt: PropTypes.string,
	response: PropTypes.object,
	otherUserResponse: PropTypes.bool,
	showUserName: PropTypes.bool,
	otherUserName: PropTypes.string,
	otherUserProfileId: PropTypes.number,
	isAdmin: PropTypes.bool,
	listData: PropTypes.object,
	listTitle: PropTypes.string,
	rating: PropTypes.number,
	showReviewName: PropTypes.bool
};

ReviewItemAboutYou.defaultProps = {
	response: null,
	showUserName: false
};

export default withStyles(s)(ReviewItemAboutYou);